const getEnumKeyByValue = (enumType: object, value: any) => {
    return Object.keys(enumType)[Object.values(enumType).indexOf(value)];
};

export { getEnumKeyByValue };
